var _require = require('prettier/standalone'),
    _require$doc$builders = _require.doc.builders,
    concat = _require$doc$builders.concat,
    group = _require$doc$builders.group,
    indent = _require$doc$builders.indent,
    join = _require$doc$builders.join,
    line = _require$doc$builders.line,
    softline = _require$doc$builders.softline;

var AssemblyCall = {
  print: function print(_ref) {
    var node = _ref.node,
        path = _ref.path,
        _print = _ref.print;

    if (node.arguments.length === 0) {
      return node.functionName;
    }

    return concat([node.functionName, '(', group(concat([indent(concat([softline, join(concat([',', line]), path.map(_print, 'arguments'))])), softline])), ')']);
  }
};
module.exports = AssemblyCall;